import { useQuery } from 'react-query';
import axios from 'axios';

export const useNavigationSettings = () => {
  return useQuery(
    'navigation-settings',
    async () => {
      const response = await axios.get('/api/navigation/settings');
      return response.data.data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1
    }
  );
};

export default useNavigationSettings;

